import { createSelector } from 'reselect'
import * as gameSelectors from '../game.selectors'

export const getPopups = createSelector(
  [gameSelectors.getCurrentScene, gameSelectors.getPopups, gameSelectors.getStoryLine],
  (currentScene, popups, storyLine) => {
    return popups
      .filter((popupId) => !!storyLine.popups[popupId])
      .map((popupId) => {
        const storyLinePopup = storyLine.popups[popupId]
        const scenePopup = (!currentScene ? {} : currentScene.popups || {})[popupId] || {}
        return { ...storyLinePopup, ...scenePopup }
      })
  }
)
